import VueApexCharts from "vue-apexcharts";
import Vue from "vue";

Vue.use(VueApexCharts);

export default VueApexCharts;
